import { render, staticRenderFns } from "./SGUsage.vue?vue&type=template&id=1cb11f3d&scoped=true&"
import script from "./SGUsage.vue?vue&type=script&lang=js&"
export * from "./SGUsage.vue?vue&type=script&lang=js&"
import style0 from "./SGUsage.vue?vue&type=style&index=0&id=1cb11f3d&lang=scss&scoped=true&"
import style1 from "./SGUsage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb11f3d",
  null
  
)

export default component.exports